const features = [
  {
    icon: 'ri-shield-check-line',
    title: 'Advanced Security',
    description:
      'Our apps use industry-leading encryption standards to protect your data and keep your digital life secure at all times.',
  },
  {
    icon: 'ri-speed-line',
    title: 'High Performance',
    description:
      'Engineered for speed and efficiency — our iOS apps run smoothly without draining your battery or slowing your device.',
  },
  {
    icon: 'ri-eye-off-line',
    title: 'Privacy First',
    description:
      'We operate a strict zero-log policy. Your browsing habits, personal data, and activity are never stored or shared.',
  },
  {
    icon: 'ri-smartphone-line',
    title: 'Native iOS Design',
    description:
      'Built from the ground up for iOS, our apps follow Apple\'s Human Interface Guidelines for a seamless, intuitive experience.',
  },
  {
    icon: 'ri-refresh-line',
    title: 'Regular Updates',
    description:
      'We continuously improve our products with new features, security patches, and performance enhancements.',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: 'Dedicated Support',
    description:
      'Our expert support team is always ready to help you get the most out of your ALFA DOO applications.',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="text-center mb-20">
          <span className="text-xs font-semibold tracking-[0.2em] uppercase text-emerald-600 mb-3 block">Why Choose Us</span>
          <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-4">Key Features</h2>
          <p className="text-gray-500 text-lg max-w-xl mx-auto leading-relaxed">
            Everything we build is guided by a commitment to quality, security, and user experience.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, idx) => (
            <div
              key={idx}
              className="bg-white rounded-2xl p-8 border border-gray-100 hover:-translate-y-1 transition-transform duration-200 group"
            >
              <div className="w-14 h-14 flex items-center justify-center rounded-2xl bg-gradient-to-br from-emerald-500 to-teal-600 mb-6 group-hover:scale-110 transition-transform duration-200">
                <i className={`${feature.icon} text-white text-2xl`} />
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-3">{feature.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
